import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import Backdrop from "Components/Common/Backdrop";
import BreadCrumb from "Components/Common/BreadCrumb";
import CalenderView from "Components/Common/CalenderView";
import SelectField from "Components/Common/SelectField";

import { useGetDeveloperBuildingsQuery } from "apis/AuditSchedular";
import { useSearchParams } from "react-router-dom";

const FireSafetyConsumerDashboard = ({ t }) => {
  const {
    data: { data: allBuildings } = {},
    isLoading: isBuildingOptionsLoading,
  } = useGetDeveloperBuildingsQuery();

  const [query, setQuery] = useState({});

  const [searchParams] = useSearchParams();
  const developerBuildingId = +searchParams.get("developerBuildingId");

  const buildingOptions = useMemo(
    () =>
      allBuildings?.map((building) => ({
        label: building.name,
        value: building.id,
      })) ?? [],
    [allBuildings]
  );

  useEffect(() => {
    if (buildingOptions.length) {
      setQuery({
        buildingId: developerBuildingId || buildingOptions[0].value,
      });
    }
  }, [buildingOptions, developerBuildingId]);

  return (
    <>
      <Backdrop open={isBuildingOptionsLoading} />
      <BreadCrumb title={t("Dashboard")} />
      <Grid container columnSpacing={2} rowSpacing={1}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <SelectField
            options={buildingOptions}
            value={
              buildingOptions.find(
                (option) => option.value === query.buildingId
              ) ?? ""
            }
            onChange={(_, option) => setQuery({ buildingId: option.value })}
          />
        </Grid>

        <Grid item xs={12}>
          <CalenderView
            buildingName={
              buildingOptions.find(
                (building) => building.value === query.buildingId
              )?.label
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

FireSafetyConsumerDashboard.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(FireSafetyConsumerDashboard);
